import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

// Main mutation - delete part file
export const useDeletePartFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      partId,
      fileId,
    }: {
      partId: string;
      fileId: string;
    }) => {
      return handleClientMethod(
        getClient().DELETE("/parts/{id}/files/{fileId}", {
          params: {
            path: {
              id: partId,
              fileId,
            },
          },
        }),
      );
    },
    onSuccess: (_, { partId }) => {
      // Invalidate parts list, get-by-id, and files queries on success
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
      queryClient.invalidateQueries({
        queryKey: ["parts", "get-by-id", partId],
      });
      queryClient.invalidateQueries({
        queryKey: ["parts", "files", partId],
      });
    },
  });
};
